import { ReactElement } from "react";
import Message from "src/shared/components/Message";
import { MessageVariant } from "src/shared/enums/messageTypes/messageTypes";

type TInfoMessageProps = {
  message: string | ReactElement;
  variant: MessageVariant;
  boldWord?: string;
  closable?: boolean;
};

function InfoMessage(props: TInfoMessageProps) {
  const { message, variant, boldWord, closable = false } = props;
  let bgColor: string, textColor: string;
  switch (variant) {
    case MessageVariant.Info:
      bgColor = "#cff4fc";
      textColor = "#055160";
      break;
    case MessageVariant.Warning:
      bgColor = "#fff3cd";
      textColor = "#59422f";
      break;
    case MessageVariant.Error:
      bgColor = "#f8d7da";
      textColor = "#842029";
      break;
    case MessageVariant.Success:
      bgColor = "#d1e7dd";
      textColor = "#0f5132";
      break;
    default:
      bgColor = "#cff4fc";
      textColor = "#055160";
      break;
  }
  return (
    <Message
      message={message}
      boldWord={boldWord}
      closable={closable}
      bgColor={bgColor}
      textColor={textColor}
      borderRadius={"5px"}
      textAlign={"start"}
      fontSize={"1rem"}
      mb={2}
    />
  );
}

export default InfoMessage;
